module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-logos/s-logo-26-a344abe55bd5620f65b168b56556f846.svg";